export const PINTEREST_LINK = 'https://www.pinterest.com/lesembellisseurs/';
export const INSTAGRAM_LINK = 'https://www.instagram.com/cleprivee/';
export const WHATSAPP_LINK = 'https://api.whatsapp.com/send?phone=33644635520';
export const CLP_LANDING_LINK = 'https://cleprivee.com';
